import React from 'react';

// Shots, Shape y Quality del generador, extraidos del RightPanel para que el
// modo Simple y el canvas editen exactamente el mismo nodo del grafo. Reciben
// `d` (node.data del generador) y `set` (patch -> updateNodeData), asi que
// ambos modos quedan sincronizados a traves del graphStore sin estado propio.

export const Row = ({ label, children }) => (
  <div className="space-y-1.5">
    <label className="text-[11px] font-medium uppercase tracking-wider text-white/50">{label}</label>
    {children}
  </div>
);

export const selCls = 'w-full rounded-md border border-[#2A2A30] bg-[#141417] px-2.5 py-2 text-sm text-white focus:border-white/30 focus:outline-none';

export default function GeneratorControls({ d, set, compiled }) {
  return (
    <>
      {/* A session, not a photograph. The back end has taken a count for a
          while and the studio has read it off this node, but there was no
          way to set it unless a recipe had already done so. */}
      <Row label="Shots">
        <div className="flex flex-wrap gap-1.5">
          {[1, 4, 6, 8, 12].map((n) => (
            <button
              key={n}
              onClick={() => set({ shots: n })}
              data-testid={`generator-shots-${n}`}
              className={`rounded-md border px-2.5 py-1 text-xs transition-colors ${
                (d.shots || 1) === n
                  ? 'border-white bg-white text-black'
                  : 'border-[#2A2A30] text-white/60 hover:text-white'}`}
            >
              {n}
            </button>
          ))}
        </div>
        <p className="mt-1 text-[10px] leading-relaxed text-white/40">
          {(d.shots || 1) > 1
            ? `${d.shots} frames, each one a different moment or angle. Charged as ${d.shots} × the tier.`
            : 'One frame. Ask for more and you get a contact sheet to pick from.'}
        </p>
      </Row>
      <Row label="Shape">
        <div className="flex flex-wrap gap-1.5">
          {/* Auto delante, porque en cualquier cosa que repare una foto es
              la unica correcta: devolver apaisado en cuadrado es recortar.
              Se marca sobre d.aspect y no sobre el compilado, que en auto
              ya trae la forma resuelta y marcaria ese boton en su lugar. */}
          {[['auto', 'Auto'], ['1:1', 'Square'], ['4:5', 'Portrait'], ['3:4', 'Tall'],
            ['4:3', 'Landscape'], ['9:16', 'Story'], ['16:9', 'Wide']].map(([v, name]) => (
            <button key={v} onClick={() => set({ aspect: v })}
                    data-testid={`generator-aspect-${v}`}
                    className={`rounded-md border px-2 py-1 text-xs transition-colors ${
                      (d.aspect || compiled?.aspect || '1:1') === v
                        ? 'border-white bg-white text-black'
                        : 'border-[#2A2A30] text-white/60 hover:text-white'}`}>
              {name}{v !== 'auto' && <span className="opacity-50"> {v}</span>}
            </button>
          ))}
        </div>
        <p className="mt-1 text-[10px] leading-relaxed text-white/40">
          {d.aspect === 'auto'
            ? `Auto keeps the shape of the photo you uploaded${
                compiled?.aspect && compiled.aspect !== 'auto'
                  ? ` — this one reads as ${compiled.aspect}` : ''}.`
            : 'Square for a listing, Portrait for a feed, Story for vertical video.'}
        </p>
      </Row>
      <Row label="Quality">
        <select className={selCls} value={d.quality} onChange={(e) => set({ quality: e.target.value })}>
          <option value="draft">Draft · 8 credits</option>
          <option value="fast">Fast · 8 credits</option>
          <option value="standard">Standard · 12 credits</option>
          <option value="premium">Premium · 32 credits</option>
        </select>
        <p className="mt-1 text-[10px] leading-relaxed text-white/40">
          Premium holds a face and a label far more faithfully.
        </p>
      </Row>
    </>
  );
}
